<template>
  <v-menu
    left
  >
    <template v-slot:activator="{ on }">
      <v-btn
        outlined
        rounded
        color="primary"
        v-on="on"
        :loading="isLoading"
      >
        Actions

        <v-icon right color="primary">more_vert</v-icon>
      </v-btn>
    </template>

    <v-list dense>
      <invoice-charge-customer-dialog
        v-if="canChargeCustomer()"
        :invoice="invoice"
        @action="onChargeCustomer"
      >
        <template v-slot:activator="{ on }">
          <v-list-item
            @click.stop=""
            v-on="on"
          >
            <v-list-item-title>
              <v-icon left small>credit_card</v-icon>
              Charge customer...
            </v-list-item-title>
          </v-list-item>
        </template>
      </invoice-charge-customer-dialog>
<!--      <confirm-action-->

<!--      />-->
      <v-list-item
        @click="emailInvoice()"
      >
        <v-list-item-title>
          <v-icon left small>send</v-icon>
          Send invoice
        </v-list-item-title>
      </v-list-item>

      <invoice-status-dialog
        v-if="canChangeStatus()"
        :invoice="invoice"
        @action="onStatusUpdate($event)"
      >
        <template v-slot:activator="{ on }">
          <v-list-item
            @click.stop=""
            v-on="on"
          >
            <v-list-item-title>
              <v-icon left small>flag</v-icon>
              Mark invoice as ...
            </v-list-item-title>
          </v-list-item>
        </template>
      </invoice-status-dialog>

      <v-list-item
        v-if="isManualDraft()"
      >
        <v-list-item-title>
          Charge customer
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        v-if="invoice.invoice_pdf"
        :href="invoice.invoice_pdf"
        download
        target="_blank"
      >
        <v-list-item-title>
          <v-icon left small>get_app</v-icon>

          Invoice PDF
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import InvoiceStatusDialog from "./InvoiceStatusDialog"
import { mapActions } from 'vuex'
import InvoiceChargeCustomerDialog from "./InvoiceChargeCustomerDialog"

export default  {
  components: { InvoiceChargeCustomerDialog, InvoiceStatusDialog },
  props: {
    invoice: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  methods: {
    ...mapActions([ 'sendInvoice' ]),
    canChargeCustomer() {
      return this.invoice.status === 'open' || this.invoice.status === 'uncollectible'
    },
    canChangeStatus() {
      return this.invoice.status === 'open' || this.invoice.status === 'uncollectible'
    },
    onChargeCustomer() {
      this.$emit('action')
    },
    onStatusUpdate() {
      this.$emit('action')
    },
    emailInvoice() {
      const payload = {
        id: this.invoice.id
      }
      this.isLoading = true
      this.sendInvoice(payload)
        .finally(() => { this.isLoading = false})
    },
    isManualDraft() {
      return this.invoice.billing_reason === 'manual'
        && this.invoice.status === 'draft'
    },
    downloadInvoicePDF() {

    }
  }
}
</script>
